import axios from "utils/axios";

class UserService {
  getUserProfile(user_id = null) {
    return axios.get(`user/profile${user_id ? `/${user_id}` : ""}`);
  }

  getUserDashboard(page = 1) {
    return axios.get(`user/dashboard`, {
      params: {
        page,
      },
    });
  }

  getPrivateChat(userId) {
    return axios.get(`user/private-chat/${userId}`);
  }

  updateUserAvatar(avatar) {
    if (avatar !== null) {
      let formData = new FormData();
      formData.append("avatar", avatar);
      return axios.post(`user/profile/avatar`, formData);
    }

    let data = {
      avatar: avatar,
    };
    return axios.post(`user/profile/avatar`, data);
  }

  updateUserCover(cover) {
    if (cover !== null) {
      let formData = new FormData();
      formData.append("cover", cover);

      return axios.post(`user/profile/cover`, formData);
    }

    let data = {
      cover: cover,
    };

    return axios.post(`user/profile/cover`, data);
  }

  updateAboutMe(about_me) {
    return axios.post(`/user/profile/aboutme`, {
      about_me,
    });
  }

  updateAboutSkills(about_skills) {
    return axios.post(`/user/profile/skills`, {
      about_skills,
    });
  }

  updateProfileBio(userProfile, body) {
    let data = {
      about_skills: body.about_skills ?? userProfile.profile.about_skills,
      email: body.email ?? userProfile.email,
      first_name: body.first_name ?? userProfile.first_name,
      geo_location: body.geo_location ?? userProfile.profile.geo_location,
      last_name: body.last_name ?? userProfile.last_name,
      location: body.location ?? userProfile.profile.location,
      phone: body.phone ?? userProfile.profile.phone,
      working_hours_start:
        body.working_hours_start ?? userProfile.profile.working_hours_start,
      working_hours_end:
        body.working_hours_end ?? userProfile.profile.working_hours_end,
      personal_hours_start:
        body.personal_hours_start ?? userProfile.profile.personal_hours_start,
      personal_hours_end:
        body.personal_hours_end ?? userProfile.profile.personal_hours_end,
      timezone: body.timezone ?? userProfile.profile.timezone,
      company_name: body.company_name ?? userProfile.profile.company_name,
      company_joined:
        body.company_joining_date ?? userProfile.profile.company_joined,
      office_work_percentage:
        body.per_of_time_office ?? userProfile.profile.office_work_percentage,
      remote_work_percentage:
        body.per_of_time_remote ?? userProfile.profile.remote_work_percentage,
    };

    return axios.post(`/user/profile/bio`, data);
  }

  updateUserMood(mood_id) {
    return axios.post(`/user/profile/mood`, { mood_id });
  }

  updateFunPic(key, image) {
    let formData = new FormData();
    formData.append(key, image);

    return axios.post(`user/profile/funpics`, formData);
  }
  /**
   *  User Strength Services
   *
   */
  getUserStrength() {
    return axios.get("user/strength");
  }
  getStrengths() {
    return axios.get(`strength`);
  }
  updateUserStrengthList(strengths) {
    let data = {
      strength_ids: [...strengths],
    };
    return axios.put(`user/strength`, data);
  }
  updateNetThrivingScore(allRatings) {
    let data = {
      career_nts: {
        one_year: allRatings[0]?.q1 || 0,
        five_year: allRatings[0]?.q2 || 0,
      },
      social_nts: {
        one_year: allRatings[1]?.q1 || 0,
        five_year: allRatings[1]?.q2 || 0,
      },
      financial_nts: {
        one_year: allRatings[2]?.q1 || 0,
        five_year: allRatings[2]?.q2 || 0,
      },
      physical_nts: {
        one_year: allRatings[3]?.q1 || 0,
        five_year: allRatings[3]?.q2 || 0,
      },
      community_nts: {
        one_year: allRatings[4]?.q1 || 0,
        five_year: allRatings[4]?.q2 || 0,
      },
    };
    return axios.put(`user/profile/net-thriving-score`, data);
  }
}

export default new UserService();
